export default "__VITE_ASSET__BU1aA3Nh__"